export const CLEAR_ERROR = 'CLEAR_ERROR'

export const clearError = () => ({
  type: CLEAR_ERROR
})



// WEBPACK FOOTER //
// ./src/actions/Error.js